import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useLocation } from 'react-router-dom';
import { useGrowers } from '../../hooks/use-growers';
import { useQuery } from '../../hooks/use-query';

const Context = React.createContext();

export const useContext = () => React.useContext(Context);

Provider.propTypes = {
  children: PropTypes.node,
};

export function Provider({ children }) {
  const queryParams = useQuery();
  const location = useLocation();
  const navigate = useNavigate();
  const { selected: growerId } = useGrowers();

  const [map, setMap] = React.useState();
  const [tab, setTab] = React.useState(queryParams.get('tab') || 'CERTIFIED');
  const [irrigationBoundaries, setIrrigationBoundaries] = React.useState();
  const [focused, setFocused] = React.useState();
  const [selected, setSelected] = React.useState([]);

  const setSelectedFeatures = React.useCallback((ids) => {
    setSelected(ids);
    setFocused(null);
  }, []);

  const state = React.useMemo(
    () => ({
      tab,
      setTab,

      map,
      setMap,

      selectedFeatures: selected,
      setSelectedFeatures,

      focusedFeature: focused,
      setFocusedFeature: setFocused,

      irrigationBoundaries,
      setIrrigationBoundaries,
    }),
    [focused, irrigationBoundaries, map, selected, setSelectedFeatures, tab],
  );

  React.useEffect(() => {
    setIrrigationBoundaries(undefined);
    setSelected([]);
  }, [growerId]);

  React.useEffect(() => {
    navigate(`${location.pathname}?tab=${tab}`, { replace: true });
  }, [navigate, location.pathname, tab]);

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
